<div>
	<ngx-skeleton-loader appearance="circle" [theme]="{ width: '180px', height: '180px' }"> </ngx-skeleton-loader>
</div>
